import { render, staticRenderFns } from "./AuthModalForgotPassword.vue?vue&type=template&id=1bea0136&scoped=true&"
import script from "./AuthModalForgotPassword.vue?vue&type=script&lang=js&"
export * from "./AuthModalForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./AuthModalForgotPassword.vue?vue&type=style&index=0&id=1bea0136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea0136",
  null
  
)

export default component.exports